import React from 'react';

/**
 * SectionHeader Component
 * Reusable section header with title, subtitle, and description
 */
const SectionHeader = ({
  title,
  subtitle,
  description,
  centered = true,
  className = '',
}) => {
  return (
    <div
      className={`
        ${centered ? 'text-center mx-auto max-w-3xl' : ''}
        ${className}
      `}
    >
      {/* Subtitle */}
      {subtitle && (
        <div className="inline-flex items-center gap-2 mb-3">
          <span className="h-px w-8 bg-bukawa-secondary" />
          <span className="text-bukawa-secondary font-medium text-sm uppercase tracking-wider">
            {subtitle}
          </span>
          <span className="h-px w-8 bg-bukawa-secondary" />
        </div>
      )}

      {/* Title */}
      {title && (
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-bukawa-gray-900 mb-4">
          {title}
        </h2>
      )}

      {/* Description */}
      {description && (
        <p className="text-lg text-bukawa-gray-600 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

/**
 * SectionContainer Component
 * Wrapper for page sections with consistent spacing
 */
export const SectionContainer = ({
  children,
  background = 'white',
  className = '',
}) => {
  const bgClasses = {
    white: 'bg-white',
    light: 'bg-bukawa-light',
    cream: 'bg-bukawa-cream',
    gray: 'bg-bukawa-gray-50',
    primary: 'bg-bukawa-primary text-white',
  };

  return (
    <section
      className={`
        section
        ${bgClasses[background] || bgClasses.white}
        ${className}
      `}
    >
      <div className="container-custom">
        {children}
      </div>
    </section>
  );
};

export default SectionHeader;